import React from "react";
import PropTypes from "prop-types";

import { OrderObject, CurrentUserObject } from "../Queries/OrderQuery";
import { useShipmentsButtonType, BUTTON_TYPES } from "./useShipmentsButtonType";
import CreateShipmentButton from "./CreateShipmentButton";
import ResendShipmentsDropdown from "./ResendShipmentsDropdown";
import CombinedShipmentsDropdown from "./CombinedShipmentsDropdown";
import DisabledShipmentsButton from "./DisabledShipmentsButton";

const ShipmentsButton = (props) => {
  const { order } = props;
  const buttonType = useShipmentsButtonType(order);

  switch (buttonType) {
    case BUTTON_TYPES.COMBINED_DROPDOWN:
      return <CombinedShipmentsDropdown {...props} />;
    
    case BUTTON_TYPES.CREATE_BUTTON:
      return <CreateShipmentButton {...props} />;
    
    case BUTTON_TYPES.RESEND_DROPDOWN:
      return <ResendShipmentsDropdown {...props} />;
    
    case BUTTON_TYPES.DISABLED:
      return <DisabledShipmentsButton />;
    
    default:
      return <DisabledShipmentsButton />;
  }
};

ShipmentsButton.propTypes = {
  order: OrderObject.isRequired,
  awaitingCallPending: PropTypes.bool.isRequired,
  currentUser: CurrentUserObject.isRequired
};

export default ShipmentsButton;
